module.exports = __webpack_public_path__ + "img/youtube.0a73be13.svg";